import Component_AssetManager_b004e9d77092ba570b938bad19a3871d from "../../../../content/examples/hooks/asset-manager/AssetManager";
import Devtool_AssetManager_b004e9d77092ba570b938bad19a3871d from "!!@devtool/loader!../../../../content/examples/hooks/asset-manager/AssetManager";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_AssetManager_b004e9d77092ba570b938bad19a3871d,
  Devtool_AssetManager_b004e9d77092ba570b938bad19a3871d,
  DevTool,
  React
};